import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveInactivePromotionReason } from 'core/slices/utils/taskIdentifiers';
import { getAisleDisplay, CardRow, StatusBadge, titleSx, captionSx } from '../taskUtils';

export default function Promotion({ task, t, brandDict, completed }) {
  const { description, product_description, code, catalog, store_info, status } = task;
  const brandName = brandDict?.[task.brand_id];
  const { title: aisleTitle, value: aisleValue } = getAisleDisplay(task, t);
  const promotionType = store_info?.promotion_type || catalog;
  const inactiveReason = resolveInactivePromotionReason(task);

  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'nowrap' }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ ...titleSx, flexShrink: 1, minWidth: 0 }}>
          {description || product_description || '—'}
        </Typography>
        {completed && <StatusBadge status={status} label={t(`bruno.task_status.${status}`, status)} />}
      </Box>
      {brandName && (
        <Typography variant="caption" color="text.disabled" display="block" sx={captionSx}>
          {brandName}
        </Typography>
      )}
      {promotionType && (
        <Typography variant="caption" color="text.disabled" display="block" sx={captionSx}>
          {promotionType}
        </Typography>
      )}
      <CardRow label={aisleTitle} value={aisleValue} labelWidth={{ xs: '9rem', md: '9rem' }} />
      <CardRow label={t('bruno.tasks_details.promotional_code', 'Promotional Code')} value={code || '-'} labelWidth={{ xs: '9rem', md: '9rem' }} />
      {inactiveReason && (
        <CardRow
          label={t('bruno.tasks_details.inactive_reason', 'Reason')}
          value={t(`bruno.promotion_reason.${inactiveReason}`, inactiveReason)}
          labelWidth={{ xs: '9rem', md: '9rem' }}
        />
      )}
    </Box>
  );
}
